import React from 'react';
import c from '../w.js';

const IconStaticStatusInfo = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
        fill: "#005CF0"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 11V17H13V11H11ZM11 7V9H13V7H11Z",
        fill: "white"
      }
    ))
  )
);

export { IconStaticStatusInfo };
